<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.sarchCardShow"
                :gutter="16">
                <Col span="24">
                <search-card :form="mainTable.searchForm"
                    :table-load-event="getBinFenCustomerUserTableRecords"
                    :table-search="mainTable.tableSearch" />
                </Col>
            </Row>
        </transition>
        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">内部客户账户列表</span>
                    </div>
                    <div class="right-bar">
                        <Button v-if="$checkAccessArray(['S'])"
                            size="small"
                            class="btns"
                            shape="circle"
                            type="success"
                            icon="ios-add-circle-outline"
                            @click="onCreateBinFenCustomerUser">新增</Button>
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.columns"
                    :data="mainTable.data"
                    :extHeight="60"
                    :loading="mainTable.loading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getBinFenCustomerUserTableRecords" />
                </Col>
            </Row>
        </Card>
        <BinFenCustomerUserEdit ref='binfenCustomerUserModal' />
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { approvalFormat, statusFormat, getapprovalFormatOptions } from '@/libs/baseModelFormat';
import { dateTimeRender } from '@/libs/tableRowTimeRender';
import BinFenCustomerUserEdit from './binFenCustomer-user-edit';
import { getExternalCustomerUserList } from '@/api/modules/account-management/externalCustomer-user-management';

export default {
    name: 'BinFenCustomerUserList',
    components: {
        SearchCard,
        StandPaginationTable,
        BinFenCustomerUserEdit
    },
    props: {
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            mainTable: {
                columns: [
                    { title: '行号', type: 'index', width: 60, align: 'center' },
                    { title: '姓名', key: 'userExternalCustomerName', align: 'center' },
                    { title: '登录账号', key: 'userName', align: 'center' },
                    { title: '区域', key: 'areaName', align: 'center' },
                    { title: '部门', key: 'departmentName', align: 'center' },
                    { title: '手机号码', key: 'userExternalCustomerPhone', align: 'center' },
                    {
                        title: '审核',
                        key: 'userExternalCustomerApproval',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {}, approvalFormat(params.row.userExternalCustomerApproval))
                            ]);
                        }
                    },
                    {
                        title: '创建时间', key: 'userExternalCustomerCreateAt', align: 'center', render: (h, params) => dateTimeRender(h, params.row.userExternalCustomerCreateAt)
                    },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    style: {
                                        visibility: this.$checkAccessArray(['S']) ? 'visible' : 'hidden'
                                    },
                                    on: {
                                        click: () => {
                                            this.onUpdateBinFenCustomerUser(params.row);
                                        }
                                    }
                                }, '编辑')
                            ]);
                        }
                    }
                ],
                data: [],
                sarchCardShow: false,
                searchForm: [
                    { label: '登陆帐号', type: 'Input', value: '', name: 'userName', sql: 'like' },
                    { label: '姓名', type: 'Input', value: '', name: 'userExternalCustomerName', sql: 'like' },
                    {
					    label: '审核状态',
					    type: 'Select',
					    value: [],
					    name: 'userExternalCustomerApproval',
					    sql: 'like',
					    options: getapprovalFormatOptions()
                    }
                ],
                loading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    created() {
        if (this.readOnly) {
            const findIndex = this.mainTable.columns.findIndex(c => c.title === "操作");
            if (findIndex >= 0) {
                this.mainTable.columns.splice(findIndex, 1);
            }
        }
    },
    mounted() {
        this.getBinFenCustomerUserTableRecords();
    },
    methods: {
        getBinFenCustomerUserTableRecords(reset = false) {
            this.mainTable.loading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }

            search.globalRemoveFilterConditionKey(this.mainTable.tableSearch, "memberType");
            this.mainTable.tableSearch.filters.enable = true;
            this.mainTable.tableSearch.filters.conditions.push({
			    name: 'memberType',
			    type: 'eq',
			    value: 'E'
            });
            getExternalCustomerUserList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.data = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.loading = false;
            }).catch(() => {
                this.mainTable.loading = false;
            });
        },
        onCreateBinFenCustomerUser() {
            this.$refs.binfenCustomerUserModal.showModal();
        },
        onUpdateBinFenCustomerUser(binFenCustomerUserRow) {
            this.$refs.binfenCustomerUserModal.showModal(binFenCustomerUserRow.userExternalCustomerLoginUuid);
        }
    }
};
</script>

<style scoped>
</style>
